import { useRoutes } from 'react-router-dom';
import routes from '../routes';

const Content = () => {
  return useRoutes(routes);
};

export default Content;
